module.exports = __webpack_public_path__ + "img/C2QB_transparent_btn_med_hover.8d74a203.svg";